import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VerifyResetPasswordComponent } from './pages/verify-reset-password/verify-reset-password.component';

@NgModule({
    declarations: [VerifyResetPasswordComponent],
    imports: [CommonModule, RouterModule],
})
export class VerifyResetPasswordModule {}
